import React from 'react';
import { apiGetSinglePrompter } from '../../../lib/apiUsers';
import { withRouter, Link } from 'react-router-dom';
import ModalConfirm from '../ModalConfirm'
import ModalDesactivar from '../modalDesactivar';
import { apiChangeStatus, apiRemoveDevice } from '../../../lib/apiUsers';
import { useState } from 'react';

const DetailsApuntador = (props) => {
    
    const { id } = props.match.params;
    const { NotificationManager } = props;

    const [prompter, setPropmter] = React.useState({ name: '', username: '', last_sync: '', device_id: '', active: true });
    
    const [modalDesactivar, setModalDesactivar] = React.useState({
        show: false,
        name: prompter.name,
        activate: true,
        type: 'desactivar',
        typeUser: 'apuntador',
        id: prompter.id
    });

    const [ modalConfirm, setModalConfirm ] = useState( { 
        show: false,
        id_device: null, 
        name: prompter.name, 
    } );

    React.useEffect(() => {
        apiGetSinglePrompter(id)
            .then(response => {
                if (response.error) {
                    // si no encontro ningun usuario deberia regresarse al listado 
                }
                else {
                    setPropmter(response);
                    setModalDesactivar({
                        show: false,
                        name: response.name,
                        typeUser: 'apuntador',
                        id: response.id
                    });
                    setModalConfirm( s => ( { 
                        ...s,
                        name: response.name,
                        id_device: response.device_id
                    } ) )
                }
            })
    }, [id])

    const handleClose = () => {
        setModalDesactivar({ ...modalDesactivar, show: false });
    }

    const ConfirmModalActivate = () => {
        apiChangeStatus(modalDesactivar.id)
            .then(response => {
                if (response.error) {
                    console.log("paso un error al desactivar");
                    NotificationManager.error("algo salio mal", '', 4000);
                } else {
                    setPropmter({ ...prompter, active: !prompter.active });
                    NotificationManager.success("Se ha cambiado el status del usuario exitósamente", '', 4000);
                }
            })
    }

    const ShowModal = () => {
        setModalDesactivar({
            ...modalDesactivar,
            type: !prompter.active ? 'activar' : 'desactivar',
            show: true,
        });
    }

    const showConfirm = () => {
        setModalConfirm( s => ({ ...s, show: true }) )
    }

    const handleCloseConfim = () => {
        setModalConfirm( s => ({ ...s, show: false }) )
    }

    const handleRemoveDevice = () => {
        apiRemoveDevice( id ).then( data => {    
            if( data.error ){
                NotificationManager.error( "Error los datos", '', 3000 )
            }else{
                NotificationManager.success("Se ha Desvinculado el dispositivo exitósamente", '', 4000);
            }
        } ).catch( err => NotificationManager.error( "Error en la peticion", '', 3000 ) )
    }

    return (<div className="">
        <div className="row ">
            <div className="col-md-6 col-12">
                <h5><i className="fas fa-arrow-left" onClick={() => props.history.goBack()} /> Detalles de apuntador</h5>
            </div>

            <div className="col-md-6 col-12 tar">
                <button className="btn btn-lgt btn-secondary" onClick={ ( )=> showConfirm( ) }><i className=" fas fa-mobile-alt" /> Desvincular Dispositivo</button>
                {
                    prompter.active ?
                        <button className="btn btn-lgt btn-danger" onClick={ShowModal}><i className="fas fa-ban" /> Desactivar</button>
                        :
                        <button className="btn btn-lgt btn-info" onClick={ShowModal}><i className="fas fa-ban" /> Activar</button>
                }
                <Link to={"/usuarios/editar/apuntador/" + id} className="btn btn-lgt btn-success"><i className="fas fa-edit" /> Editar</Link>
            </div>

        </div>
        <div className="card separate">
            <div className="card-body">
                <h4>Información apuntador</h4>
                <hr />
                <div className="row">
                    <div className="col-md-4 col-12">
                        <p className="lbl-title">Nombre apuntador</p>
                        <label>{prompter.name}</label>
                    </div>
                    <div className="col-md-4 col-12">
                        <p className="lbl-title">Nombre usuario</p>
                        <label>{prompter.username}</label>
                    </div>
                    <div className="col-md-4 col-12">
                        <p className="lbl-title">Última sincronización</p>
                        <label>{prompter.last_sync}</label>
                    </div>

                </div>
                <div className="row separate">
                    <div className="col-md-4 col-12">
                        <p className="lbl-title">Dispositivo vinculado</p>
                        <label>{prompter.device_id}</label>
                    </div>
                </div>
            </div>

            <ModalDesactivar
                {...modalDesactivar}
                confirm={ConfirmModalActivate}
                handleClose={handleClose}
            />

            <ModalConfirm 
                { ...modalConfirm } 
                confirm={ handleRemoveDevice } 
                handleClose={ handleCloseConfim } 
            />

        </div>


    </div>)
}

export default withRouter(DetailsApuntador);